// extracted by mini-css-extract-plugin
export default {"container":"gRmuU","details":"Jke6-","skeleton-progress":"_7prhJ"};